import { GridRequest } from 'projects/app-core/src/models/gridRequest';
import { GridResponse } from 'projects/app-core/src/models/gridResponse';

export enum LyfisPersistedUsersSort {
  LATEST_SNAPSHOT_CREATED_AT = 'latestSnapshotCreatedAt',
  LYFIS_SNAPSHOT_COUNT = 'lyfisSnapshotCount',
  LATEST_GHS = 'latestGhs',
}

export enum LyfisPersistedUsersFilter {
  PARTNER_ID = 'partnerId',
  LATEST_GHS_BAND = 'latestGhsBand',
  TEST_USERS = 'TEST_USERS',
}

export enum LyfisPersistedUsersSearch {
  PARTNER_ID = 'partnerId',
}

export enum LyfisPersistedUsersDateFilter {
  LATEST_SNAPSHOT_CREATED_AT = 'latestSnapshotCreatedAt',
}

export interface LyfisPersistedUsersGridRequest
  extends GridRequest<
    LyfisPersistedUsersSort,
    LyfisPersistedUsersFilter,
    LyfisPersistedUsersSearch,
    LyfisPersistedUsersDateFilter
  > {}

export interface LyfisPersistedUsersGridRow {
  userId: string;
  userEmail: string;
  lyfisSnapshotCount: number;
  latestGhs: number;
  latestGhsBand: string | null;
  latestSnapshotCreatedAt?: number;
  partnerId?: string;
  latestTrigger?: 'lab' | 'questionnaire';
}

export interface LyfisPersistedUsersFilterData {
  partnerId?: string[];
  latestGhsBand?: string[];
}

export interface LyfisPersistedUsersGridResponse
  extends GridResponse<LyfisPersistedUsersFilterData | undefined, LyfisPersistedUsersGridRow> {}
